import React from "react";
import { useRouteError, Link } from "react-router-dom";

export default function ErrorPage() {
  const error = useRouteError();
  console.error(error);

  // Define styles as a JavaScript object
  const styles = {
    errorPage: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      height: "100vh",
      textAlign: "center",
      backgroundColor: "#f8f9fa",
      color: "#333",
      padding: "20px",
      fontFamily: "'Arial', sans-serif",
    },
    errorTitle: {
      fontSize: "3rem",
      marginBottom: "1rem",
      color: "#e63946",
    },
    errorMessage: {
      fontSize: "1.25rem",
      marginBottom: "1rem",
    },
    errorDetail: {
      fontStyle: "normal",
      color: "#555",
    },
    errorLink: {
      color: "#007bff",
      textDecoration: "none",
      fontWeight: "bold",
      marginTop: "20px",
    },
    errorLinkHover: {
      textDecoration: "underline",
    },
  };

  return (
    <div id="error-page" style={styles.errorPage}>
      <h1 style={styles.errorTitle}>Oops!</h1>
      <p style={styles.errorMessage}>
        Sorry, an unexpected error has occurred.
      </p>
      <p style={styles.errorDetail}>
        <i>{error.statusText || error.message}</i>
      </p>
      <Link
        style={styles.errorLink}
        onMouseOver={(e) => (e.target.style.textDecoration = "underline")}
        onMouseOut={(e) => (e.target.style.textDecoration = "none")}
      >
        Go back to Home
      </Link>
    </div>
  );
}
